import { useQueryClient } from '@tanstack/react-query';

import type { SearchTendersPreviewResponseDTO } from '../../../../../shared/api/magellan/tender/dto';
import type { SearchTendersPreviewQueryKey } from './useStreamForm';

export const MAX_TENDER_PREVIEW_COUNT = 99;

export function usePreviewDiff(queryKeys: SearchTendersPreviewQueryKey[]) {
  const queryClient = useQueryClient();

  const currentQueryData =
    queryClient.getQueryData<SearchTendersPreviewResponseDTO>(queryKeys[0]);

  if (queryKeys.length === 0 || !currentQueryData?.resultsPreview) {
    return { preview: null, hasNewTenders: false };
  }

  const currentResultsPreview = currentQueryData.resultsPreview;

  const lastQueryData =
    queryClient.getQueryData<SearchTendersPreviewResponseDTO>(queryKeys[1]);

  if (
    !lastQueryData?.resultsPreview ||
    currentResultsPreview.length > MAX_TENDER_PREVIEW_COUNT
  ) {
    return { preview: currentResultsPreview, hasNewTenders: false };
  }

  const lastResultsPreview = lastQueryData.resultsPreview;
  const diffCount = currentResultsPreview.length - lastResultsPreview.length;

  if (diffCount > 0) {
    const lastPreviewIds = lastResultsPreview.map(tender => tender.id);
    const currentPreviewIds = currentResultsPreview.map(tender => tender.id);

    const previewIds = currentPreviewIds.filter(
      id => !lastPreviewIds.includes(id),
    );

    const preview = currentResultsPreview.filter(tender =>
      previewIds.includes(tender.id),
    );

    return { preview, hasNewTenders: true };
  } else if (lastResultsPreview.length > MAX_TENDER_PREVIEW_COUNT) {
    return { preview: currentResultsPreview, hasNewTenders: false };
  } else {
    return { preview: [], hasNewTenders: false };
  }
}
